import { DateTime } from "luxon";

export const defaultDashboardStartDate = (): string =>
  DateTime.now().startOf("year").toISODate()!;

export const defaultDashboardEndDate = (): string =>
  DateTime.now().toISODate()!;
